import { createClass as _createClass, classCallCheck as _classCallCheck, typeof as _typeof } from './_virtual/_rollupPluginBabelHelpers.js';
import { queryObject, setValueByQuery } from './object.js';
import startsWith$1 from 'lodash/startsWith';

var Repository = /*#__PURE__*/function () {
  function Repository() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Repository);

    this._observeCallbacks = {};
    this.data = data;
  }

  _createClass(Repository, [{
    key: "transform",
    value: function transform(query, callback) {
      var value = this.get(query);

      if (typeof callback === "function") {
        value = callback(value);
      }

      this.set(query, value);
    }
  }, {
    key: "get",
    value: function get(query) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (arguments.length === 0) {
        return this.data;
      }

      return queryObject(this.data, query, defaultValue);
    }
  }, {
    key: "set",
    value: function set(query, value) {
      // Check if query is an object
      if (_typeof(query) === "object") {
        this.data = query;
        return this;
      }

      setValueByQuery(this.data, query, value);
      this.triggerObserveCallbacks(query);
      return this;
    }
  }, {
    key: "remove",
    value: function remove(query) {
      var parts = query.split(".");
      var key = parts.pop();
      var parentQuery = parts.join(".");
      var target = parts.length === 0 ? this.get() : this.get(parentQuery);

      if (target && _typeof(target) === "object") {
        delete target[key];
      }

      this.triggerObserveCallbacks(query);
      return this;
    }
  }, {
    key: "has",
    value: function has(query) {
      return this.get(query) != undefined;
    }
  }, {
    key: "empty",
    value: function empty() {
      this.data = {};
      return this;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return Object.keys(this.data) === 0;
    }
  }, {
    key: "keys",
    value: function keys() {
      return Object.keys(this.data);
    }
  }, {
    key: "entries",
    value: function entries() {
      return Object.values(this.data);
    }
  }, {
    key: "each",
    value: function each(callback) {
      if (typeof callback !== "function") {
        return;
      }

      if (this.isEmpty()) {
        return;
      }

      return this.entries().map(function (entry) {
        return callback(entry);
      });
    }
  }, {
    key: "observe",
    value: function observe(path, callback) {
      var _this = this;

      if (typeof this._observeCallbacks[path] === 'undefined') {
        this._observeCallbacks[path] = [];
      }

      var disposer = function disposer() {
        _this.removeObserveListener(path, callback);
      };

      this._observeCallbacks[path].push(callback);

      return disposer;
    }
  }, {
    key: "triggerObserveCallbacks",
    value: function triggerObserveCallbacks(path) {
      var _this2 = this;

      var allPaths = Object.keys(this._observeCallbacks);

      if (allPaths.length > 0) {
        allPaths.forEach(function (pathEntry) {
          if (pathEntry === path || startsWith$1(pathEntry, path + '.')) {
            _this2.triggerObserveCallbacksForPath(pathEntry);
          }
        });
      }
    }
  }, {
    key: "triggerObserveCallbacksForPath",
    value: function triggerObserveCallbacksForPath(path) {
      var callbacks = this._observeCallbacks[path];

      if (typeof callbacks !== 'undefined' && callbacks.length > 0) {
        callbacks.forEach(function (_callback, index) {
          _callback();
        });
      }
    }
  }, {
    key: "removeObserveListener",
    value: function removeObserveListener(path, callback) {
      var _this3 = this;

      if (typeof this._observeCallbacks[path] === 'undefined' || this._observeCallbacks[path].length === 0) {
        return;
      }

      this._observeCallbacks[path].forEach(function (_callback, index) {
        if (_this3._observeCallbacks[path][index] === callback) {
          delete _this3._observeCallbacks[path][index];
        }
      });
    }
  }]);

  return Repository;
}();

export default Repository;
//# sourceMappingURL=repository.js.map
